var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "75%" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "preparacion-equipos__modal-series",
          staticStyle: { "padding-left": "0px !important" },
          attrs: { dark: "", color: "primary" }
        },
        [
          _c(
            "v-flex",
            { attrs: { layout: "", "align-center": "", md6: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.handleShowPopUp({})
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "#f5f5f5" } }, [
                    _vm._v("close")
                  ])
                ],
                1
              ),
              _c("v-toolbar-title", [
                _vm._v("\n        Lista de equipos para finalizar\n      ")
              ])
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "div",
            { attrs: { align: "left" } },
            [_c("FormFieldsContainer")],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Buscar...",
                          outlined: "",
                          "append-icon": "search",
                          clearable: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.gridApi.setQuickFilter(_vm.quickSearch)
                          }
                        },
                        model: {
                          value: _vm.quickSearch,
                          callback: function($$v) {
                            _vm.quickSearch = $$v
                          },
                          expression: "quickSearch"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("AgGridVue", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                ],
                1
              ),
              !_vm.download
                ? _c(
                    "v-layout",
                    { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                      _vm.btnIsClose
                        ? _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm4: "", md3: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver white--text",
                                  on: { click: _vm.handleClosedModal }
                                },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm4: "", md3: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleShowPopUp({})
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "white--text" }, [
                                    _vm._v("Cancelar")
                                  ])
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn_confirmar",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleShowPopUp({
                                        isClose: false
                                      })
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "white--text" }, [
                                    _vm._v("Confirmar")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("Confirmation", {
            attrs: {
              show: _vm.dialogPopUp,
              titulo: _vm.titlePopUp,
              mensaje: _vm.msgPopUp,
              textoBtnSi: _vm.btnTextConfirmation,
              textoBtnNo: _vm.btnTextCancel
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.popUpOpened($event)
              }
            }
          })
        ],
        1
      ),
      _vm.showFinalizando
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c(
                          "h2",
                          {
                            staticClass: "importExportBtnIcon",
                            staticStyle: { "font-size": "25px!important" }
                          },
                          [
                            _vm._v(
                              "\n              Finalizando Preparación " +
                                _vm._s(_vm.data.asignumero) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "h2",
                          {
                            staticClass: "importExportBtnIcon",
                            staticStyle: { "font-size": "20px!important" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.data.asigrequerimiento) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _c("div", {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      }),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticStyle: { background: "#536da5" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "v-progress-linear mb-0",
                              staticStyle: { height: "7px" },
                              attrs: {
                                role: "progressbar",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "v-progress-linear__background white",
                                staticStyle: {
                                  height: "7px",
                                  opacity: "0.3",
                                  width: "100%"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "v-progress-linear__bar" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "v-progress-linear__bar__indeterminate long white"
                                      }),
                                      _c("div", {
                                        staticClass:
                                          "v-progress-linear__bar__indeterminate short white"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_finalizando))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" })
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }